import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getParentIdWorkoutUtil (workout) {
  return getValueReduxUtil(workout, WORKOUT_KEY.PARENT_ID)
}

export default getParentIdWorkoutUtil
